/** User identification utilities for the Engagement Predictor application. */

import { auth } from '../lib/firebase';

const DEFAULT_USER_EMAIL = 'eq.ai.platform@gmail.com';

/**
 * Get the current user email from Firebase Auth or return default.
 */
export function getUserEmail(): string {
  if (typeof window === 'undefined') {
    return DEFAULT_USER_EMAIL;
  }
  
  // Use Firebase Auth if available
  const user = auth.currentUser;
  if (user?.email) {
    return user.email;
  }
  
  return DEFAULT_USER_EMAIL;
}

/**
 * Set the user email in localStorage (kept for backward compatibility).
 * Note: This function is deprecated - use Firebase Auth instead.
 */
export function setUserEmail(email: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  
  // Validate email format
  if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    // Still allow localStorage for backward compatibility
    const USER_EMAIL_KEY = 'engagement_predictor_user_email';
    localStorage.setItem(USER_EMAIL_KEY, email);
  } else {
    console.warn('Invalid email format:', email);
  }
}

/**
 * Clear the user email from localStorage (kept for backward compatibility).
 * Note: This function is deprecated - Firebase Auth handles user state.
 */
export function clearUserEmail(): void {
  if (typeof window === 'undefined') {
    return;
  }
  
  const USER_EMAIL_KEY = 'engagement_predictor_user_email';
  localStorage.removeItem(USER_EMAIL_KEY);
}

/**
 * Check if user email is set (not using default).
 * Note: This function checks localStorage for backward compatibility.
 */
export function hasCustomUserEmail(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  
  // Check Firebase Auth first
  if (auth.currentUser?.email) {
    return true;
  }
  
  // Fallback to localStorage check
  const USER_EMAIL_KEY = 'engagement_predictor_user_email';
  return localStorage.getItem(USER_EMAIL_KEY) !== null;
}
